import moment from 'moment';
import { dateFormat } from '../../../constants';
import { getStopApi } from '../../../services/StopApi/StopApi';

export const getEpisodeList = async ({ commonParams, authorization }) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    //console.log(response);
    const json = response.data;
    return {
      isLoading: false,
      total: response?.totalRows,
      data: json?.map((item, index) => ({
        ...item,
        id: item.episodeID ? item.episodeID : '',
        episodeID: item.episodeID ? item.episodeID : '',
        episodeSAPStartDate: item.episodeSAPStartDate
          ? moment(item.episodeSAPStartDate).format(dateFormat).split('T')[0]
          : '',
        expectedEPRD: item.expectedEPRD
          ? moment(item.expectedEPRD).format(dateFormat).split('T')[0]
          : '',
        actualAPRD: item.actualAPRD
          ? moment(item.actualAPRD).format(dateFormat).split('T')[0]
          : '',
        incarcerationInstitution: item.incarcerationInstitution?.value
          ? item.incarcerationInstitution?.value
          : '',
        referralSource: item.referralSource?.value
          ? item.referralSource?.value
          : '',
        cDCNumber: item.cDCNumber ? item.cDCNumber : '',
        cCCMS: item.cCCMS,
        tIR: item.tIR,
        episodeDischargeDate: item.episodeDischargeDate
          ? moment(item.episodeDischargeDate).format(dateFormat).split('T')[0]
          : '',
        inactivity: item.inactivity,
        area: item.area?.value ? item.area?.value : '',
        paroleAgent: item.paroleAgent?.value ? item.paroleAgent?.value : '',
        paroleCounty: item.paroleCounty?.value ? item.paroleCounty?.value : '',
        lastCountyofResidence: item.lastCountyofResidence
          ? item.lastCountyofResidence?.value
          : '',
        episodeDischargeReason: item.EpisodeDischargeReason
          ? item.EpisodeDischargeReason?.value
          : '',
        incarcerationInstitutionId: item.incarcerationInstitution,
        episodeDischargeReasonId: item.EpisodeDischargeReason,
        lastCountyofResidenceId: item.lastCountyofResidence,
        referralSourceId: item.referralSource,
        paroleCountyId: item.paroleCounty,
        paroleAgentId: item.paroleAgent,
        areaId: item.area,
      })),
    };
  }).catch((e) => alert(e));
};
